import * as actionTypes from "../../actionLabels/index";

const initialState = {
  viewTeaSold: [],
  viewTeaSoldLot: [],
  viewTeaSoldMarket: [],
  viewTeaAuctioneer: [],
  viewMarketSummary: [],
  myPlanner: [],
  Viewcatalog: [],
  error: null,
  loading: false,
  loadingCatalog: false,
  loadingPlanner: false,
  loadingViewTeaSold: false,
  loadingViewTeaLot: false,
  loadingTeaSoldLotMarket: false,
  loadingAuctionneer: false,
  loadingMarketSummary: false,
  loadingMarketDepth: false,
  Addcatalog: [],
  Removecatalog: [],
  catalogdata: false,
  Adddata: false,
  Removedata: false,
  changePrice: [],
  mymarketdepth: [],
  error: null,
  Changedata: false,
  columnConfig: [],
  userWisecolumnConfig: [],
  defultcolumnConfig: [],
  userWiseStutas: false,
  defaultStutas: false,
  groupCodedata: [],
  AddValuation: [],
  valueStatus: false,
  isRpButtonClicked : false
};

const teaTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_MY_VIEW_TEA_VIEW_LOADING:
      return {
        ...state,
        loadingViewTeaSold: true,
      };

    case actionTypes.GET_VIEW_TEA_SOLD_SUCCESS:
      return {
        ...state,
        viewTeaSold: action.payload,
        error: null,
        loadingViewTeaSold: false,
      };
    case actionTypes.GET_VIEW_TEA_SOLD_FAIL:
      return {
        ...state,
        viewTeaSold: null,
        error: action.payload,
        loadingViewTeaSold: false,
      };
    case actionTypes.GET_MY_VIEW_TEA_LOT_VIEW_LOADING:
      return {
        ...state,
        loadingViewTeaLot: true,
      };
    case actionTypes.GET_VIEW_TEA_SOLD_LOT_SUCCES:
      return {
        ...state,
        viewTeaSoldLot: action.payload,
        error: null,
        loadingViewTeaLot: false,
      };
    case actionTypes.GET_VIEW_TEA_SOLD_LOT_FAIL:
      return {
        ...state,
        viewTeaSoldLot: null,
        error: action.payload,
        loadingViewTeaLot: false,
      };
    case actionTypes.GET_MY_VIEW_TEA_SOLD_VIEW_LOADING:
      return {
        ...state,
        loadingTeaSoldLotMarket: true,
      };

    case actionTypes.GET_VIEW_TEA_SOLD_LOT_MARKET_SUCCES:
      return {
        ...state,
        viewTeaSoldMarket: action.payload,
        error: null,
        loadingTeaSoldLotMarket: false,
      };
    case actionTypes.GET_VIEW_TEA_SOLD_LOT_MARKET_FAIL:
      return {
        ...state,
        viewTeaSoldMarket: null,
        error: action.payload,
        loadingTeaSoldLotMarket: false,
      };
    case actionTypes.GET_MY_AUCTIONEER_VIEW_LOADING:
      return {
        ...state,
        loadingAuctionneer: true,
      };

    case actionTypes.GET_VIEW_TEA_AUCTIONEER_SUCCES:
      return {
        ...state,
        viewTeaAuctioneer: action.payload,
        error: null,
        loadingAuctionneer: false,
      };
    case actionTypes.GET_VIEW_TEA_AUCTIONEER_FAIL:
      return {
        ...state,
        viewTeaAuctioneer: null,
        error: action.payload,
        loadingAuctionneer: false,
      };

    case actionTypes.GET_MY_VIEW_MARKET_VIEW_LOADING:
      return {
        ...state,
        loadingMarketSummary: true,
      };
    case actionTypes.GET_VIEW_MARKET_SUMMARY_SUCCES:
      return {
        ...state,
        viewMarketSummary: action.payload,
        error: null,
        loadingMarketSummary: false,
      };
    case actionTypes.GET_VIEW_MARKET_SUMMARY_FAIL:
      return {
        ...state,
        viewMarketSummary: null,
        error: action.payload,
        loadingMarketSummary: false,
      };
    case actionTypes.GET_MY_PLANNER_VIEW_LOADING:
      return {
        ...state,
        loadingPlanner: true,
      };

    case actionTypes.GET_MY_PLANNER_ENG_SUCCES:
      return {
        ...state,
        myPlanner: action.payload,
        error: null,
        loadingPlanner: false,
      };
    case actionTypes.GET_MY_PLANNER_ENG_FAIL:
      return {
        ...state,
        myPlanner: null,
        error: action.payload,
        loadingPlanner: false,
      };

    case actionTypes.GET_MY_CATALOG_VIEW_LOADING:
      return {
        ...state,
        loadingCatalog: true,
      };

    case actionTypes.GET_MY_CATALOG_VIEW_SUCCES:
      return {
        ...state,
        Viewcatalog: action.payload,
        error: null,
        loadingCatalog: false,
      };
    case actionTypes.GET_MY_CATALOG_VIEW_FAIL:
      return {
        ...state,
        Viewcatalog: null,
        error: action.payload,
        loadingCatalog: false,
      };

    case actionTypes.GET_MY_CATALOG_ADD_SUCCES:
      return {
        ...state,
        Addcatalog: action.payload,
        error: null,
      };
    case actionTypes.GET_MY_CATALOG_ADD_FAIL:
      return {
        ...state,
        Addcatalog: null,
        error: action.payload,
      };
    case actionTypes.GET_MY_CATALOG_REMOVE_SUCCES:
      return {
        ...state,
        Removecatalog: action.payload,
        error: null,
      };
    case actionTypes.GET_MY_CATALOG_REMOVE_FAIL:
      return {
        ...state,
        Removecatalog: null,
        error: action.payload,
      };

    case actionTypes.CHANGE_RESERVE_PRICE_SUCCES:
      return {
        ...state,
        changePrice: action.payload,
        error: null,
      };
    case actionTypes.CHANGE_RESERVE_PRICE_FAIL:
      return {
        ...state,
        changePrice: null,
        error: action.payload,
      };
    case actionTypes.GET_MY_CATALOG_STUTAS:
      return {
        ...state,
        catalogdata: action.payload.data,
      };

    case actionTypes.ADD_MY_CATALOG_STUTAS:
      return {
        ...state,
        Adddata: action.payload.data,
      };

    case actionTypes.REMOVE_MY_CATALOG_STUTAS:
      return {
        ...state,
        Removedata: action.payload.data,
      };
    case actionTypes.CHANGE_PRICE_STUTAS:
      return {
        ...state,
        Changedata: action.payload.data,
      };
    case actionTypes.GET_MY_MARKET_DEPTH_VIEW_LOADING:
      return {
        ...state,
        loadingMarketDepth: true,
      };

    case actionTypes.GET_MARKET_DEPTH_SUCCES:
      return {
        ...state,
        mymarketdepth: action.payload,
        error: null,
        loadingMarketDepth: false,
      };
    case actionTypes.GET_MARKET_DEPTH_FAIL:
      return {
        ...state,
        mymarketdepth: null,
        error: action.payload,
        loadingMarketDepth: false,
      };

    case actionTypes.COLUMN_CONFIG_TABLE_SUCCES:
      return {
        ...state,
        columnConfig: action.payload,
        error: null,
      };
    case actionTypes.COLUMN_CONFIG_TABLE_FAIL:
      return {
        ...state,
        columnConfig: null,
        error: action.payload,
      };

    case actionTypes.USERWISE_CONFIG_TABLE_SUCCES:
      return {
        ...state,
        userWisecolumnConfig: action.payload,
        error: null,
      };
    case actionTypes.USERWISE_CONFIG_TABLE_FAIL:
      return {
        ...state,
        userWisecolumnConfig: null,
        error: action.payload,
      };
    case actionTypes.DEFULT_CONFIG_TABLE_SUCCES:
      return {
        ...state,
        defultcolumnConfig: action.payload,
        error: null,
      };
    case actionTypes.DEFULT_CONFIG_TABLE_FAIL:
      return {
        ...state,
        defultcolumnConfig: null,
        error: action.payload,
      };
    case actionTypes.USERWISE_CATALOG_STUTAS:
      return {
        ...state,
        userWiseStutas: action.payload.data,
      };
    case actionTypes.DEFUALT_CATALOG_STUTAS:
      return {
        ...state,
        defaultStutas: action.payload.data,
      };

    case actionTypes.GROUP_CODE_TABLE_SUCCES:
      return {
        ...state,
        groupCodedata: action.payload,
        error: null,
      };
    case actionTypes.GROUP_CODE_TABLE_FAIL:
      return {
        ...state,
        groupCodedata: null,
        error: action.payload,
      };
    case actionTypes.ADD_VALUATION_ACTION_SUCCES:
      return {
        ...state,
        AddValuation: action.payload,
        error: null,
      };
    case actionTypes.ADD_VALUATION_ACTION_FAIL:
      return {
        ...state,
        AddValuation: null,
        error: action.payload,
      };
    case actionTypes.VALUE_STUTAS:
      return {
        ...state,
        valueStatus: action.payload.data,
      };

      case actionTypes.IS_RP_BUTTON_CLICKED_TRUE:
        return {
          ...state,
         isRpButtonClicked: true
        };

        case actionTypes.IS_RP_BUTTON_CLICKED_FALSE:
          return {
            ...state,
           isRpButtonClicked: false
          };

    default:
      return state;
  }
};

export default teaTypeReducer;
